import { NgModule } from '@angular/core';
import { DhhpCardComponent } from './dhhp-card.component';
import { DhhpCardActionsComponent } from './dhhp-card-actions/dhhp-card-actions.component';
import { DhhpCardContentComponent } from './dhhp-card-content/dhhp-card-content.component';
import { DhhpCardHeaderComponent } from './dhhp-card-header/dhhp-card-header.component';
import { DhhpCardSubtitleComponent } from './dhhp-card-subtitle/dhhp-card-subtitle.component';
import { DhhpCardTitleComponent } from './dhhp-card-title/dhhp-card-title.component';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [DhhpCardComponent, DhhpCardActionsComponent, DhhpCardContentComponent, DhhpCardHeaderComponent, DhhpCardSubtitleComponent, DhhpCardTitleComponent],
  imports: [
    MatCardModule
  ],
  exports: [MatCardModule,DhhpCardComponent, DhhpCardActionsComponent, DhhpCardContentComponent, DhhpCardHeaderComponent, DhhpCardSubtitleComponent, DhhpCardTitleComponent]
})
export class DhhpCardModule { }
